import { render, html, nothing } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { styleMap } from "lit-html/directives/style-map.js";
import { translate } from "@escapio/shared/l10n/translate";
import { getFormatter } from "@escapio/shared/l10n/currency";
import { travelData } from "../state/travelData";
import { debounce } from "@escapio/shared/event/debounce";
import { getSliderValue, getStateValue } from "./hotel-list/PriceFilterMaps";

export default class extends HTMLElement {
	constructor() {
		super();
		this.debouncedDispatch = debounce(300, this.notifyStore.bind(this));
		this.disabled = false;
		this.min = null;
		this.max = null;
		this.value = null;
		this.format = null;
		this.histogram = null;
		this.histogramMax = null;
	}

	updateAndRender(state, { isLoading, priceHistogram }) {
		if (
			state.priceFilterRange &&
			state.priceFilterRange[0] != state.priceFilterRange[1]
		) {
			this.min = state.priceFilterRange[0];
			this.max = state.priceFilterRange[1];
		}
		this.format = getFormatter(travelData.currency);
		this.value = state.filters.price || this.max;
		this.hideCompletely = !isLoading && (!this.min || !this.max);
		this.disabled = isLoading || !this.min || !this.max;
		this.histogram = priceHistogram;
		this.histogramMax = priceHistogram ? Math.max(...priceHistogram) : null;

		this.render();
	}

	render() {
		const sliderValue = this.disabled
			? 0
			: getSliderValue(this.value, this.min, this.max);

		this.style.display = this.hideCompletely ? "none" : "";

		const template = html`<label>
			<div class="slider-label filter-box__section-title">
				${translate("hotel_list_price_filter_header_total_price")}
				<span
					class="slider-label__value ${classMap({
						"slider-label__value--active": this.value != this.max,
					})}"
				>
					${this.format(this.value)}
				</span>
			</div>
			<div
				class="price-histogram ${classMap({
					"price-histogram--shown": !!this.histogram,
				})}"
			>
				${this.histogram
					? html`<div
									class="price-histogram__overlay"
									style=${styleMap({
										"--esc-slider-progress": `${sliderValue * 100}%`,
									})}
								></div>
								${this.histogram.map(
									count =>
										html`<div
											class="price-histogram__class"
											style=${styleMap({
												"--esc-histogram-weight": `${
													(100 * count) / this.histogramMax
												}%`,
											})}
										></div>`,
								)}
						</div>`
					: nothing}
			</div>
			<div class="slider-container">
				<input
					class="slider"
					type="range"
					min="0"
					max="1"
					step="0.01"
					style=${styleMap({
						"--esc-slider-progress": `${sliderValue * 100}%`,
					})}
					.value=${sliderValue}
					?disabled=${this.disabled}
					@input=${this.onInput}
					@change=${this.onChange}
				/>
			</div>
		</label>`;
		render(template, this, { host: this });
	}

	onInput({ target }) {
		this.value = getStateValue(target.value, this.min, this.max);
		this.render();
		this.debouncedDispatch();
	}

	notifyStore() {
		if (this.value == this.max) {
			this.onChangeMax();
		} else {
			this.onChangeValue(this.value);
		}
	}
}
